import React, { useState } from "react";
import { useCollapse } from "react-collapsed";
import { Link } from "react-router-dom";
import './Collapsible.css';
import FormAvis from "./FormAvis";

export default function Collapsible() {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  return (
    <div className="laisser-avis">
      <a className="linkAvis"
        {...getToggleProps({
          onClick: () => setExpanded((prevExpanded) => !prevExpanded),
        })}
      >
        Laisser un avis
        {/* {isExpanded ? "Laisser un avis" : "Laisser un avis"} */}
      </a>
      <section {...getCollapseProps()}>
        <FormAvis></FormAvis>
      </section>
    </div>
  );
}